const actions = {
  SET_AVATAR: 'SET_AVATAR',
  GET_AVATAR: 'GET_AVATAR',
  setAvatar: infoAvatar => ({
    type: actions.SET_AVATAR,
    infoAvatar,
  })
};
export default actions;